const SimilarCardSkeleton = () => {
  return (
    <>
      <div className="shadow-lg rounded-lg animate-pulse bg-gray-200">
        <div className="h-32 bg-gray-300 rounded-t-lg"></div>
        <div className="p-4 space-y-2">
          <div className="h-4 bg-gray-300 rounded"></div>
          <div className="h-3 bg-gray-300 rounded w-3/4"></div>
          <div className="h-3 bg-gray-300 rounded w-1/2"></div>
        </div>
        <div className="mt-4 p-4">
          <div className="h-6 bg-gray-300 rounded"></div>
          <div className="h-3 bg-gray-300 rounded w-2/3 mt-2"></div>
          <div className="h-3 bg-gray-300 rounded w-1/2 mt-2"></div>
        </div>
        <div className="absolute top-3 right-3 h-5 w-5 bg-gray-300 rounded-full"></div>
      </div>
    </>
  );
};
export default SimilarCardSkeleton;
